import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";

export const collectionType =
  blocksOptionsConfig.collectionTypes.contactsTabs.value;

export const contactsTabConfig = newCollectionTemplate({
  typeFields: {
    label: "text",
    code: "text",
    isShow: "boolean",
  },
  itemTemplate: {
    label: "",
    code: "",
    isShow: true,
  },
  type: collectionType,
  showAsTitle: "label", // only texts fields
});

// export const contactsTabConfig1 = {
//   typeFields: {
//     label: "text",
//     code: "text",
//   },
//   itemTemplate: {
//     label: "",
//     code: "",
//   },
//   type: collectionType,
//   showAsTitle: "label", // only texts fields
// };

export const tabTemplate = {
  title: "",
  subTitle: "",
  links: {
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
  },
  phoneNumber: "",
  email: "",
  content: "",
};

export const initBlockData = {
  title: "Lux Express contacts",
  collections: {
    [collectionType]: {
      ...contactsTabConfig,
      items: [
        {
          isShow: true,
          label: "Estonia",
          code: "estonia",
        },
      ],
    },
  },

  countriesData: {
    tabTemplate,
    countries: {
      estonia: {
        ...tabTemplate,
        title: "Lux Express in Estonia",
        subTitle: "Description Lux Express in Estonia",
        phoneNumber: "+372 680 0909",
        content:
          '<p><strong>For ticket refund, please use self-service: </strong><a href="https://luxexpress.eu/en/manage-booking/"><strong>https://luxexpress.eu/en/manage-booking/</strong></a></p><p>&nbsp;</p><p><strong>The departures are taking place as scheduled - add the desired date to the travel search to see if your trip is taking place.</strong></p><p><strong>In case of questions regarding travel conditions or documents, please read the "</strong><a href="https://luxexpress.eu/en/news/travel-info"><strong>Travel Information</strong></a><strong>" in advance.</strong></p><p><strong>To change your ticket (date, time) please use Lux Express self-service: </strong><a href="https://luxexpress.eu/en/manage-booking"><strong>https://luxexpress.eu/en/manage-booking</strong></a></p><p><strong>Please call only for time-critical topics and for general questions, please use forms. In this way, we can better serve those who have urgent questions related to travel, etc.</strong></p><p><br>Customer service answers every day from 09:00 to 18:00 in Estonian, English and Russian.</p><p><strong>NB! </strong>Purchasing a ticket from Tpilet or via Lux Express customer service phone, there is a service fee added to the ticket price.&nbsp;<br>Purchasing the ticket online from Lux Express website is free of charge.</p>',
      },
    },
  },
};

export const initEmptyBlockData = {
  title: "",
  collections: {
    [collectionType]: {
      ...contactsTabConfig,
      items: [
        {
          label: "Estonia",
          code: "estonia",
        },
      ],
    },
  },

  countriesData: {
    tabTemplate,
    countries: {
      estonia: {
        ...tabTemplate,
        title: "",
        subTitle: "",
        phoneNumber: "",
        content: "",
      },
    },
  },
};
